import React from "react";

import {
  CodeCellIcon,
  EyeOpenIcon,
  NewThreadIcon,
  NotebookViewIcon,
} from "../icons/CustomIcons";

/** Stable view ids for plain-code project shell tabs (do not rename). */
export const PLAIN_CODE_PROJECT_VIEW = {
  chat: "chat",
  notebook: "notebook",
  code: "code",
  preview: "preview",
} as const;

export type PlainCodeProjectView =
  (typeof PLAIN_CODE_PROJECT_VIEW)[keyof typeof PLAIN_CODE_PROJECT_VIEW];

export type PlainCodeProjectViewDefinition = {
  readonly id: PlainCodeProjectView;
  readonly label: string;
  readonly icon: React.ReactElement;
};

export const PLAIN_CODE_PROJECT_VIEW_DEFINITIONS: ReadonlyArray<PlainCodeProjectViewDefinition> =
  [
    {
      id: PLAIN_CODE_PROJECT_VIEW.chat,
      label: "Chat",
      icon: <NewThreadIcon />,
    },
    {
      id: PLAIN_CODE_PROJECT_VIEW.notebook,
      label: "Notebook",
      icon: <NotebookViewIcon />,
    },
    {
      id: PLAIN_CODE_PROJECT_VIEW.code,
      label: "Code",
      icon: <CodeCellIcon />,
    },
    {
      id: PLAIN_CODE_PROJECT_VIEW.preview,
      label: "Preview",
      icon: <EyeOpenIcon />,
    },
  ];

export const DEFAULT_PLAIN_CODE_PROJECT_OPEN_VIEWS: ReadonlyArray<PlainCodeProjectView> =
  [PLAIN_CODE_PROJECT_VIEW.chat];

export const PLAIN_CODE_PROJECT_SCREENSHOT_OPEN_VIEWS: ReadonlyArray<PlainCodeProjectView> =
  [PLAIN_CODE_PROJECT_VIEW.preview];

/** Max content width for the Chat tab agent UI (matches logic-view fullscreen threads). */
export const PLAIN_CODE_PROJECT_FULLSCREEN_CHAT_CONTENT_MAX_WIDTH = 760;
